import { render, staticRenderFns } from "./forgotten.vue?vue&type=template&id=7bd0ee94"
import script from "./forgotten.vue?vue&type=script&lang=ts"
export * from "./forgotten.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports